import React from 'react';
import '../styles/Article.css';
import CodeBlock from './CodeBlock';

function Article({ article }) {
  return (
    <div className="article-container">
      <div className="article-header">
        <span className="article-category">{article.category}</span>
        <h1 className="article-title-article">{article.title}</h1>
      </div>
      
      <div className="article-featured-image">
        <img src={article.image} alt={article.title} />
      </div>
      
      <div className="article-content">
        {article.content}
      </div>
      
      <div className="article-tags">
        {article.tags && article.tags.map((tag, index) => (
          <span key={index} className="article-tag">#{tag}</span>
        ))}
      </div>
      
      <div className="article-share">
        <h4>Share this article</h4>
        <div className="share-buttons">
          <a href="#" className="share-button"><i className="fab fa-twitter"></i></a>
          <a href="#" className="share-button"><i className="fab fa-facebook-f"></i></a>
          <a href="#" className="share-button"><i className="fab fa-linkedin-in"></i></a>
          <a href="#" className="share-button"><i className="far fa-envelope"></i></a>
        </div>
      </div>
    </div>
  );
}

export default Article;
